// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iOC5","question":"styles_question__3aLsV","inputVisibleButton":"styles_inputVisibleButton__3j6GC","note":"styles_note__SP5A1"};